import { defineMessages } from 'react-intl';

const messages = defineMessages({
  return_est_text: {
    id: 'lwF2PS',
    defaultMessage: 'Return to the pricing page',
  },
  feat_label: {
    id: 'ZXp0z1',
    defaultMessage: 'Features',
  },
  prcie_text: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  estimated_one_time_cost_text: {
    id: 'TTZNM2',
    defaultMessage: 'Estimated one time cost',
  },
  bp_desc: {
    id: '9k14Pe',
    defaultMessage:
      'I consent to IBM providing my business contact information: ',
  },
  col3_text: {
    id: 'b1zuN9',
    defaultMessage: 'Price',
  },
  contact_info: {
    id: 'ic57NA',
    defaultMessage:
      'For more information regarding this offering and industry solutions please get in touch with us.',
  },
  gi_sub_headline: {
    id: '5hupvB',
    defaultMessage:
      'Start your estimate with no commitment, and explore IBM’s pricing for your unique usage requirements.',
  },
  close_btn_text: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  est_label: {
    id: 'LkpytJ',
    defaultMessage: 'GI Essentials',
  },
  tooltip_slider2_text: {
    id: 'kvbXeN',
    defaultMessage:
      'Count the total number of users across all your applications. For example, if an employee uses both Slack and Jira, that is considered two application users.',
  },
  std_tile_desc: {
    id: 'w8niPG',
    defaultMessage:
      'This edition is best suited for organizations focused on data compliance and are looking for an introduction to data security.',
  },
  dspm_tile_desc: {
    id: 'Se7bUK',
    defaultMessage:
      'IBM Guardium Insights SaaS DSPM gives you the ability to discover shadow data, analyze data flow, and uncover vulnerabilities across your cloud and SaaS applications.',
  },
  gi_slider2_text: {
    id: 'ZMmd82',
    defaultMessage: 'How many total users across apps do you have?',
  },
  gi_main_headline: {
    id: '1jPVw0',
    defaultMessage:
      'Get an instant price estimate for IBM Security Guardium Insights',
  },
  contact_sales: {
    id: '9kC9wc',
    defaultMessage: 'Pricing details on AWS',
  },
  quote_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  key3_text: {
    id: '+vPapi',
    defaultMessage: 'Documents / year',
  },
  package_label: {
    id: 'RcNFA2',
    defaultMessage: 'Package',
  },
  col2_text: {
    id: '8dIVt+',
    defaultMessage: 'Offering',
  },
  std_label: {
    id: 'LNhuQB',
    defaultMessage: 'GI Standard',
  },
  summary_text2: {
    id: 'DUIDEq',
    defaultMessage: 'Storage',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  summary_text3: {
    id: 'kF+LjE',
    defaultMessage: 'Total Users Across Apps',
  },
  prem_label: {
    id: 'a85GB3',
    defaultMessage: 'GI Premium',
  },
  est_tile_desc: {
    id: 'VSwd8V',
    defaultMessage:
      'This cost-effective solution is best suited for small and mid-sized enterprises that are new to the compliance world and want to easily solve their data regulation challenges.',
  },
  summary_text1: {
    id: 'GXb+7K',
    defaultMessage: 'Data Stores',
  },
  col1_text: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  book_text: {
    id: 'KTmxQU',
    defaultMessage: 'Book a consultation',
  },
  gi_slider1_text: {
    id: 'U/DTFx',
    defaultMessage: 'How many data stores do you have?',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  tooltip_slider1_text: {
    id: 'h8TV9i',
    defaultMessage:
      'The place where data is stored (e.g. database, Slack channel, Google Personal Drive)',
  },
  dspm_label: {
    id: 'SdyJfG',
    defaultMessage: 'GI DSPM',
  },
  prem_tile_desc: {
    id: '6id2Xi',
    defaultMessage:
      'This edition is geared toward large enterprises that want to mature their data security progam with automated threat detection in addition to meeting regulatory requirements.',
  },
  estimated_monthly_text: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  estimated_annual_text: {
    id: 'QsT4P9',
    defaultMessage: 'Estimated annual cost',
  },
  key2_text: {
    id: 'EFWGgA',
    defaultMessage: 'Maps',
  },
  prem_notif_label: {
    id: 'vt9nHB',
    defaultMessage: 'Information notification',
  },
  inline_saas: {
    id: 'pzhawg',
    defaultMessage: 'Software as a Service information',
  },
  inline_saas_description: {
    defaultMessage:
      'All the benefits of Guardium Insights without needing to invest in hardware and software.',
    id: 'kelMmM',
  },
  inline_sw: {
    id: 'CI1KvW',
    defaultMessage: 'Software subscription information',
  },
  inline_sw_description: {
    defaultMessage: 'Pricing does not include the cost of infrastructure.',
    id: 'mQxRPU',
  },
});

export default messages;
